import { gql } from "@apollo/client";

export const GET_ALL_DONATION_ITEMS = gql`
  query GetAllDonationItems {
    getAllDonationItems {
      donation_item_id
      donation_id
      item_name
      item_description
      item_pic_url
      donor_pic_url
      created_at
    }
  }
`;

export const GET_DONATION_ITEM_BY_ID = gql`
  query GetDonationItemById($donation_item_id: ID!) {
    getDonationItemById(donation_item_id: $donation_item_id) {
      donation_item_id
      donation_id
      item_name
      item_description
      item_pic_url
      donor_pic_url
      created_at
    }
  }
`;

export const GET_DONATION_ITEMS_BY_DONATION_ID = gql`
  query GetDonationItemsByDonationId($donation_id: ID!) {
    getDonationItemsByDonationId(donation_id: $donation_id) {
      donation_item_id
      donation_id
      item_name
      item_description
      item_pic_url
      donor_pic_url
      created_at
    }
  }
`;





export const CREATE_DONATION_ITEM = gql`
  mutation CreateDonationItem($input: createDonationItemInput) {
    createDonationItem(input: $input) {
      donation_item_id
      donation_id
      item_name
      item_description
      item_pic_url
      donor_pic_url
      created_at
    }
  }
`;

export const UPDATE_DONATION_ITEM = gql`
  mutation UpdateDonationItem($input: updateDonationItemInput) {
    updateDonationItem(input: $input) {
      donation_item_id
      donation_id
      item_name
      item_description
      item_pic_url
      donor_pic_url
      created_at
    }
  }
`;

export const DELETE_DONATION_ITEM = gql`
  mutation DeleteDonationItem($donation_item_id: ID!) {
    deleteDonationItem(donation_item_id: $donation_item_id)
  }
`;
